import { Injectable } from '@angular/core';
import {
  TextPosition,
  TextTopologyProcessService,
  TopologyStyle,
} from './text-topology-process.service';
import { TextCell } from '../../studio.types';

@Injectable({ providedIn: 'root' })
export class TextDescriptorGeneratorService {
  constructor(
    private readonly textTopologyService: TextTopologyProcessService,
  ) {
    // -- // -- //
  }

  generateDescriptor(cell: TextCell): Partial<TextCell> {
    const descriptor = this._generateDescriptor(cell);

    let align: 'left' | 'center' | 'right' = 'left';

    switch (descriptor.position) {
      case TextPosition.LEFT_TOP:
      case TextPosition.LEFT_BOTTOM:
        align = 'left';
        break;
      case TextPosition.RIGHT_TOP:
      case TextPosition.RIGHT_BOTTOM:
        align = 'right';
        break;
      case TextPosition.CENTER:
      default:
        align = 'center';
        break;
    }
    // -- // -- //

    return {
      ...descriptor,
      align,
    };
  }
  _generateDescriptor(cell: TextCell): Partial<TextCell> {
    const { text, topology, position } = cell;

    // -- //

    const letterLength = text
      .split(/\s+/)
      .filter(word => word.length > 0).length;

    // - //
    const contentWidth = 0.7;
    const contentHeight = 0.7;

    if (letterLength == 1) {
      return {
        topology: TopologyStyle.SingleLine,
        position: this.getNextTextPosition(position),
        contentWidth,
        contentHeight,
      };
    }

    if (letterLength > 10) {
      return {
        topology: TopologyStyle.MultiLine,
        position: TextPosition.CENTER,
        contentWidth,
        contentHeight,
      };
    }

    // -- //
    // let nextTopology: TopologyStyle;
    // switch (topology) {
    //   case TopologyStyle.SingleLine:
    //     nextTopology = TopologyStyle.TwoLine;
    //     break;
    //   case TopologyStyle.TwoLine:
    //     nextTopology = TopologyStyle.MultiLine;
    //     break;
    //   case TopologyStyle.MultiLine:
    //     nextTopology = TopologyStyle.WordIsLine;
    //     break;
    //   case TopologyStyle.WordIsLine:
    //     nextTopology = TopologyStyle.WordIsLine;
    //     break;
    //   default:
    //     nextTopology = TopologyStyle.MultiLine;
    //     break;
    // }

    const randomTopology = this.textTopologyService.getRandomTopology(
      text,
      topology,
    );

    return {
      topology: randomTopology,
      position: this.getNextTextPosition(position),
      contentWidth,
      contentHeight,
    };
  }

  getNextTextPosition(position: TextPosition): TextPosition {
    switch (position) {
      case TextPosition.LEFT_TOP:
        return TextPosition.LEFT_BOTTOM;
      case TextPosition.LEFT_BOTTOM:
        return TextPosition.CENTER;
      case TextPosition.CENTER:
        return TextPosition.RIGHT_TOP;
      case TextPosition.RIGHT_TOP:
        return TextPosition.RIGHT_BOTTOM;
      case TextPosition.RIGHT_BOTTOM:
        return TextPosition.LEFT_TOP;
      default:
        return TextPosition.CENTER;
    }
  }
}
